import React, {useState} from 'react';
import { Modal, ModalHeader, ModalBody, Button, ButtonToolbar } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import AddProgramForm from '../../components/AddProgramForm';

const NewSubProgramModal = ({data, isOpen, toggle, theme, rtl, organization}) => {
    return (
    <Modal className={`modal-program manager-program-modal modal-lg ${theme.className} ${rtl.direction}-support`} isOpen={isOpen} toggle={toggle}>
        <ModalHeader tag="div" className="manager-program-modal__header">
            <div className="manager-program-modal__header-row">
                <div className="manager-program-modal__header-copy">
                    <h3 className="manager-program-modal__title">Create Subprogram</h3>
                    <p className="manager-program-modal__subtitle">
                        Create a new child program directly under {data.name}.
                    </p>
                </div>
                <ButtonToolbar className="manager-program-modal__actions">
                    <Button outline color="primary" onClick={toggle}>Close</Button>
                </ButtonToolbar>
            </div>
        </ModalHeader>
        <ModalBody className="manager-program-modal__body">
            <AddProgramForm organization={organization} program={data} toggle={toggle} />
        </ModalBody>
    </Modal>
    )
}
NewSubProgramModal.propTypes = {
  theme: ThemeProps.isRequired,
  rtl: RTLProps.isRequired,
  organization: Object.isRequired,
  data: Object.isRequired
};

export default connect((state) => ({
  theme: state.theme,
  rtl: state.rtl,
  organization: state.organization,
  data: state.program
}))(NewSubProgramModal);
